import Field from 'components/common/fields/Field';

const LoanNumber = (props) => <Field {...props} />;

export default LoanNumber;
